<div
    class="
        container-fluid
        p-0
        action-configurator-wrapper
        h-100
        overflow-hidden
    "
>
    <div class="row element-wrapper overflow-hidden h-100">
        <div class="col-2 overflow-hidden h-100">
            <div
                class="
                    elm-detail-wrapper elm-detail-left-side
                    h-100
                    overflow-hidden
                "
            >
                <p class="title">
                    {{
                        'neuralNetwork.actionConfigurator.sideBarHeader'
                            | translate
                    }}
                </p>
                <ul class="scene-elements-list tryb-scroll">
                    <li
                        *ngFor="let sceneElement of sceneElements; index as i"
                        (click)="onSelectElement(i)"
                        class="scene-element"
                        [class.selected]="selectedElementIndex === i"
                    >
                        <span>
                            {{ sceneElement.browserAndPhysicsLoadable.name }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-10">
            <div class="elm-detail-wrapper elements-details-container h-100">
                <div class="h-100" *ngIf="sceneElements.length > 0">
                    <p class="title">
                        {{
                            sceneElements[selectedElementIndex]
                                .browserAndPhysicsLoadable.name
                        }}
                    </p>
                    <div class="tables-container tryb-scroll">
                        <div>
                            <p>
                                <strong>{{
                                    'neuralNetwork.actionConfigurator.controllerConfiguration.header'
                                        | translate
                                }}</strong>
                            </p>
                            <table
                                class="table table-hover"
                                *ngIf="specifications.length > 0"
                            >
                                <caption hidden>
                                    List of Controller Configurations
                                </caption>
                                <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">
                                            {{
                                                'neuralNetwork.actionConfigurator.controllerConfiguration.table.rightColumn'
                                                    | translate
                                            }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="
                                            let controllerConfig of specifications[
                                                selectedElementIndex
                                            ].controllerConfigurations
                                        "
                                    >
                                        <td>
                                            {{
                                                'neuralNetwork.actionConfigurator.controllerConfiguration.table.' +
                                                    controllerConfig.name
                                                    | translate
                                            }}
                                        </td>
                                        <td>
                                            <app-algorithm-input
                                                inputLabel=""
                                                [required]="true"
                                                type="text"
                                                [control]="
                                                    form
                                                        .get(
                                                            'controllerConfigurations'
                                                        )
                                                        .get(
                                                            controllerConfig.name
                                                        )
                                                "
                                                [hasSteppers]="
                                                    controllerConfig.type ===
                                                        ControllerConfigurationValueTypes.DOUBLE ||
                                                    controllerConfig.type ===
                                                        ControllerConfigurationValueTypes.INTEGER
                                                "
                                                [isFloatingPoint]="
                                                    controllerConfig.type ===
                                                    ControllerConfigurationValueTypes.DOUBLE
                                                "
                                                [decimalPlaces]="3"
                                            ></app-algorithm-input>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <p>
                                <strong>{{
                                    'neuralNetwork.actionConfigurator.actionSpaceConfiguration.header'
                                        | translate
                                }}</strong>
                            </p>
                            <table
                                class="table table-hover"
                                *ngIf="specifications.length > 0"
                            >
                                <caption hidden>
                                    List of Action Space Configurations
                                </caption>
                                <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">
                                            {{
                                                'neuralNetwork.actionConfigurator.actionSpaceConfiguration.table.rightColumn'
                                                    | translate
                                            }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Action Space</td>
                                        <td>
                                            <div
                                                class="
                                                    d-flex
                                                    justify-content-start
                                                "
                                            >
                                                <div class="tryb-dropdown">
                                                    <select
                                                        id="action-space-dropdown"
                                                        [formControl]="
                                                            form.get(
                                                                'actionSpaceConfiguration'
                                                            )
                                                        "
                                                    >
                                                        <option
                                                            *ngFor="
                                                                let actionSpace of actionSpaceTypes
                                                            "
                                                            [value]="
                                                                actionSpace
                                                            "
                                                            [id]="actionSpace"
                                                        >
                                                            {{ actionSpace }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
